import React from 'react';
import {
  Container,
  Typography,
  Box,
  Grid,
  Card,
  CardContent,
  Paper,
  Avatar,
  Breadcrumbs,
  Link as MuiLink,
  Fade,
  Slide,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Chip,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Alert
} from '@mui/material';
import {
  NavigateNext as NavigateNextIcon,
  LocalShipping as LocalShippingIcon,
  Schedule as ScheduleIcon,
  LocationOn as LocationOnIcon,
  Payment as PaymentIcon,
  Security as SecurityIcon,
  CheckCircle as CheckCircleIcon,
  Cancel as CancelIcon,
  Warning as WarningIcon,
  Info as InfoIcon,
  ExpandMore as ExpandMoreIcon,
  Speed as SpeedIcon,
  Verified as VerifiedIcon,
  AccessTime as AccessTimeIcon,
  MonetizationOn as MonetizationOnIcon,
  Store as StoreIcon,
  DirectionsBus as DirectionsBusIcon,
  TwoWheeler as TwoWheelerIcon,
  Agriculture as AgricultureIcon
} from '@mui/icons-material';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

const DeliveryPolicy = () => {
  const deliveryTypes = [
    {
      icon: <StoreIcon />,
      title: 'একই বাজার ডেলিভারি',
      description: 'আপনার নির্বাচিত বাজার থেকে পণ্য ক্রয়ের ক্ষেত্রে',
      cost: '২০-৪০ টাকা',
      time: '২-৪ ঘন্টা',
      color: '#4CAF50'
    },
    {
      icon: <TwoWheelerIcon />,
      title: 'একই উপজেলা ডেলিভারি',
      description: 'আপনার উপজেলার অন্য বাজার থেকে পণ্য ক্রয়ের ক্ষেত্রে',
      cost: '৫০-১০০ টাকা',
      time: '৪-৮ ঘন্টা',
      color: '#2196F3'
    },
    {
      icon: <DirectionsBusIcon />,
      title: 'ক্রস উপজেলা ডেলিভারি',
      description: 'অন্য উপজেলার বাজার থেকে পণ্য ক্রয়ের ক্ষেত্রে',
      cost: '১০০-২৫০ টাকা',
      time: '১-৩ দিন',
      color: '#FF9800'
    },
    {
      icon: <VerifiedIcon />,
      title: 'ক্যাশ অন ডেলিভারি',
      description: 'পণ্য হাতে পেয়ে টাকা পরিশোধ করুন',
      cost: 'অতিরিক্ত ১৫ টাকা',
      time: 'সব ধরনের ডেলিভারিতে',
      color: '#9C27B0'
    }
  ];

  const deliveryAreas = [
    {
      area: 'একই বাজার (ডিফল্ট বাজার)',
      time: '২-৪ ঘন্টা',
      cost: '১০-৩০ টাকা',
      transport: 'রিকশা/ভ্যান',
      description: 'হাঁটা বা রিকশার ভাড়ার সমান'
    },
    {
      area: 'একই উপজেলার অন্য বাজার',
      time: '৪-৮ ঘন্টা',
      cost: '৩০-৬০ টাকা',
      transport: 'অটো/সিএনজি',
      description: 'অটোরিকশা বা সিএনজির ভাড়ার সমান'
    },
    {
      area: 'পার্শ্ববর্তী উপজেলা',
      time: '১-২ দিন',
      cost: '৬০-৮০ টাকা',
      transport: 'বাস/টেম্পো',
      description: 'বাস ভাড়া + স্থানীয় পরিবহন খরচ'
    },
    {
      area: 'দূরবর্তী উপজেলা',
      time: '২-৩ দিন',
      cost: '৮০-১০০ টাকা',
      transport: 'বাস/ট্রাক',
      description: 'দূরত্ব অনুযায়ী পরিবহন খরচ'
    },
    {
      area: 'জেলার বাইরে',
      time: '৩-৫ দিন',
      cost: '১০০-১৫০ টাকা',
      transport: 'ট্রাক/কুরিয়ার',
      description: 'আন্তঃজেলা পরিবহন খরচ'
    }
  ];

  const deliveryTerms = [
    {
      title: 'ডেলিভারি সময়সূচী',
      items: [
        'সকাল ৮টা থেকে সন্ধ্যা ৭টা পর্যন্ত ডেলিভারি',
        'শুক্রবার ও হাটের দিন বিশেষ ব্যবস্থা',
        'বর্ষাকালে ডেলিভারি সময় বৃদ্ধি পেতে পারে',
        'ডেলিভারির আগে মোবাইলে যোগাযোগ করা হবে'
      ]
    },
    {
      title: 'গ্রামীণ ডেলিভারি শর্তাবলী',
      items: [
        'সঠিক গ্রাম ও ইউনিয়নের নাম উল্লেখ করুন',
        'স্থানীয় পরিচিত ব্যক্তির রেফারেন্স দিন',
        'পণ্য গ্রহণের সময় উপস্থিত থাকুন',
        'কাঁচা রাস্তার কারণে বিলম্ব হতে পারে'
      ]
    },
    {
      title: 'বিশেষ নির্দেশনা',
      items: [
        'কৃষি পণ্যের জন্য বিশেষ প্যাকেজিং',
        'দুর্গম এলাকায় অতিরিক্ত সময় লাগতে পারে',
        'বন্যা/প্রাকৃতিক দুর্যোগে ডেলিভারি স্থগিত',
        'ভারী পণ্যের জন্য অতিরিক্ত চার্জ প্রযোজ্য'
      ]
    }
  ];

  const deliveryIssues = [
    {
      issue: 'ভুল ঠিকানা',
      solution: 'স্থানীয় রেফারেন্স দিয়ে সমাধান',
      icon: <WarningIcon sx={{ color: '#FF9800' }} />
    },
    {
      issue: 'কাঁচা রাস্তা',
      solution: 'আবহাওয়া ভালো হলে ডেলিভারি',
      icon: <AgricultureIcon sx={{ color: '#8BC34A' }} />
    },
    {
      issue: 'মোবাইল নেটওয়ার্ক সমস্যা',
      solution: 'স্থানীয় যোগাযোগকারীর মাধ্যমে',
      icon: <InfoIcon sx={{ color: '#2196F3' }} />
    },
    {
      issue: 'হাট/বাজারের দিন',
      solution: 'পরের দিন ডেলিভারির ব্যবস্থা',
      icon: <ScheduleIcon sx={{ color: '#9C27B0' }} />
    }
  ];

  return (
    <>
      <Header />
      <Box sx={{ bgcolor: '#f8fafc', minHeight: '100vh' }}>
        {/* Hero Section */}
        <Box
          sx={{
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            color: 'white',
            py: 8,
            position: 'relative',
            overflow: 'hidden'
          }}
        >
          <Container>
            <Breadcrumbs 
              separator={<NavigateNextIcon fontSize="small" />} 
              aria-label="breadcrumb"
              sx={{ mb: 4, '& .MuiBreadcrumbs-separator': { color: 'rgba(255,255,255,0.7)' } }}
            >
              <MuiLink component={Link} to="/" sx={{ color: 'rgba(255,255,255,0.8)' }}>
                হোম
              </MuiLink>
              <Typography sx={{ color: 'white' }}>ডেলিভারি নীতিমালা</Typography>
            </Breadcrumbs>

            <Fade in timeout={1000}>
              <Box sx={{ textAlign: 'center', mb: 6 }}>
                <Typography variant="h2" component="h1" gutterBottom sx={{ fontWeight: 700, mb: 2 }}>
                  গ্রামীণ ডেলিভারি নীতিমালা
                </Typography>
                <Typography variant="h5" sx={{ opacity: 0.9, maxWidth: '800px', mx: 'auto' }}>
                  উপজেলা ভিত্তিক ডেলিভারি সেবা - আপনার যাতায়াত খরচের সমান ডেলিভারি চার্জ
                </Typography>
              </Box>
            </Fade>
          </Container>
        </Box>

        <Container sx={{ py: 6 }}>
          {/* Delivery Types */}
          <Box sx={{ mb: 8, pt: '80px' }}>
            <Typography variant="h3" component="h2" gutterBottom sx={{ fontWeight: 600, textAlign: 'center', mb: 6 }}>
              উপজেলা ভিত্তিক ডেলিভারি সেবা
            </Typography>
            <Grid container spacing={2.5} sx={{ px: 2 }}>
              {deliveryTypes.map((type, index) => (
                <Grid item xs={12} sm={6} md={3} key={index} sx={{ mb: 2 }}>
                  <Slide direction="up" in timeout={800 + index * 200}>
                    <Card
                      sx={{
                        textAlign: 'center',
                        p: 3,
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        transition: 'all 0.3s ease',
                        '&:hover': {
                          transform: 'translateY(-4px)',
                          boxShadow: '0 8px 24px rgba(0,0,0,0.12)'
                        },
                        border: '1px solid #e2e8f0',
                        borderRadius: 2,
                        mx: 1,
                        mt: 1
                      }}
                    >
                      <Avatar
                        sx={{
                          bgcolor: type.color,
                          width: 64,
                          height: 64,
                          mx: 'auto',
                          mb: 2
                        }}
                      >
                        {type.icon}
                      </Avatar>
                      <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, mb: 1.5 }}>
                        {type.title}
                      </Typography>
                      <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.6, mb: 2, flexGrow: 1 }}>
                        {type.description}
                      </Typography>
                      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, mt: 'auto' }}>
                        <Chip 
                          label={type.cost} 
                          color="primary" 
                          sx={{ fontWeight: 600 }}
                        />
                        <Chip 
                          label={type.time} 
                          variant="outlined"
                          size="small"
                        />
                      </Box>
                    </Card>
                  </Slide>
                </Grid>
              ))}
            </Grid>
          </Box>

          {/* Delivery Areas Table */}
          <Box sx={{ mb: 8, pt: '80px' }}>
            <Typography variant="h3" component="h2" gutterBottom sx={{ fontWeight: 600, textAlign: 'center', mb: 6 }}>
              ডেলিভারি এলাকা ও যাতায়াত ভিত্তিক চার্জ
            </Typography>
            <TableContainer component={Paper} sx={{ border: '1px solid #e2e8f0' }}>
              <Table>
                <TableHead>
                  <TableRow sx={{ bgcolor: '#f8fafc' }}>
                    <TableCell sx={{ fontWeight: 600, fontSize: '1.1rem' }}>ডেলিভারি এলাকা</TableCell>
                    <TableCell sx={{ fontWeight: 600, fontSize: '1.1rem' }}>সময়</TableCell>
                    <TableCell sx={{ fontWeight: 600, fontSize: '1.1rem' }}>চার্জ</TableCell>
                    <TableCell sx={{ fontWeight: 600, fontSize: '1.1rem' }}>পরিবহন</TableCell>
                    <TableCell sx={{ fontWeight: 600, fontSize: '1.1rem' }}>বিবরণ</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {deliveryAreas.map((area, index) => (
                    <TableRow key={index} sx={{ '&:hover': { bgcolor: '#f8fafc' } }}>
                      <TableCell sx={{ fontWeight: 500 }}>{area.area}</TableCell>
                      <TableCell>{area.time}</TableCell>
                      <TableCell sx={{ color: '#667eea', fontWeight: 600 }}>{area.cost}</TableCell>
                      <TableCell>
                        <Chip 
                          label={area.transport}
                          color="primary"
                          size="small"
                          variant="outlined"
                        />
                      </TableCell>
                      <TableCell sx={{ fontSize: '0.9rem', color: 'text.secondary' }}>
                        {area.description}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>

          {/* Delivery Terms */}
          <Box sx={{ mb: 8, pt: '80px' }}>
            <Typography variant="h3" component="h2" gutterBottom sx={{ fontWeight: 600, textAlign: 'center', mb: 6 }}>
              গ্রামীণ ডেলিভারি শর্তাবলী
            </Typography>
            <Grid container spacing={4}>
              {deliveryTerms.map((term, index) => (
                <Grid item xs={12} md={4} key={index}>
                  <Fade in timeout={1000 + index * 200}>
                    <Card sx={{ height: '100%', border: '1px solid #e2e8f0' }}>
                      <CardContent sx={{ p: 4 }}>
                        <Typography variant="h5" gutterBottom sx={{ fontWeight: 600, color: '#4CAF50', mb: 3 }}>
                          {term.title}
                        </Typography>
                        <List>
                          {term.items.map((item, itemIndex) => (
                            <ListItem key={itemIndex} sx={{ px: 0, py: 1 }}>
                              <ListItemIcon sx={{ minWidth: 36 }}>
                                <CheckCircleIcon color="primary" fontSize="small" />
                              </ListItemIcon>
                              <ListItemText 
                                primary={item} 
                                sx={{ 
                                  '& .MuiListItemText-primary': { 
                                    fontSize: '0.95rem',
                                    lineHeight: 1.6
                                  } 
                                }} 
                              />
                            </ListItem>
                          ))}
                        </List>
                      </CardContent>
                    </Card>
                  </Fade>
                </Grid>
              ))}
            </Grid>
          </Box>

          {/* Delivery Issues */}
          <Box sx={{ mb: 8, pt: '80px' }}>
            <Typography variant="h3" component="h2" gutterBottom sx={{ fontWeight: 600, textAlign: 'center', mb: 6 }}>
              গ্রামীণ ডেলিভারি চ্যালেঞ্জ ও সমাধান
            </Typography>
            <Grid container spacing={4}>
              {deliveryIssues.map((issue, index) => (
                <Grid item xs={12} sm={6} md={3} key={index}>
                  <Fade in timeout={1200 + index * 200}>
                    <Card
                      sx={{
                        textAlign: 'center',
                        p: 3,
                        height: '100%',
                        border: '1px solid #e2e8f0',
                        transition: 'all 0.3s ease',
                        '&:hover': {
                          transform: 'translateY(-2px)',
                          boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
                        }
                      }}
                    >
                      <Box sx={{ mb: 2 }}>
                        {issue.icon}
                      </Box>
                      <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
                        {issue.issue}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        {issue.solution}
                      </Typography>
                    </Card>
                  </Fade>
                </Grid>
              ))}
            </Grid>
          </Box>

          {/* Important Notes */}
          <Box sx={{ mb: 8, pt: '80px' }}>
            <Typography variant="h3" component="h2" gutterBottom sx={{ fontWeight: 600, textAlign: 'center', mb: 6 }}>
              গুরুত্বপূর্ণ তথ্য
            </Typography>
            <Grid container spacing={4}>
              <Grid item xs={12} md={6}>
                <Alert severity="info" sx={{ mb: 3 }}>
                  <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
                    বিনামূল্যে ডেলিভারি
                  </Typography>
                  <Typography variant="body2">
                    ৫০০ টাকার উপরে অর্ডারে একই বাজার থেকে বিনামূল্যে ডেলিভারি। 
                    ১০০০ টাকার উপরে অর্ডারে একই উপজেলায় বিনামূল্যে ডেলিভারি।
                  </Typography>
                </Alert>
              </Grid>
              <Grid item xs={12} md={6}>
                <Alert severity="success" sx={{ mb: 3 }}>
                  <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
                    যাতায়াত খরচ ভিত্তিক চার্জ
                  </Typography>
                  <Typography variant="body2">
                    আমাদের ডেলিভারি চার্জ আপনার সেই দোকানে যেতে যে খরচ হতো 
                    ঠিক সেই পরিমাণ অর্থ। কোনো অতিরিক্ত লাভ নেই।
                  </Typography>
                </Alert>
              </Grid>
            </Grid>
          </Box>

          {/* Detailed Terms */}
          <Box sx={{ mb: 8, pt: '80px' }}>
            <Typography variant="h3" component="h2" gutterBottom sx={{ fontWeight: 600, textAlign: 'center', mb: 6 }}>
              বিস্তারিত শর্তাবলী
            </Typography>
            <Paper sx={{ p: 4, border: '1px solid #e2e8f0' }}>
              <Accordion defaultExpanded>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography variant="h6" sx={{ fontWeight: 600 }}>
                    উপজেলা ভিত্তিক ডেলিভারি সিস্টেম
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
                    গ্রামীণ বাজার উপজেলা ভিত্তিক কাজ করে। প্রতিটি উপজেলায় একাধিক বাজার রয়েছে। 
                    আপনি একটি ডিফল্ট বাজার নির্বাচন করবেন যা আপনার সবচেয়ে কাছের বাজার।
                  </Typography>
                  <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
                    আপনার ডিফল্ট বাজার থেকে কিনলে ডেলিভারি চার্জ কম, দূরের বাজার থেকে কিনলে বেশি। 
                    অন্য উপজেলা থেকে কিনলে আরও বেশি সময় ও চার্জ লাগবে।
                  </Typography>
                </AccordionDetails>
              </Accordion>

              <Accordion>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography variant="h6" sx={{ fontWeight: 600 }}>
                    গ্রামীণ এলাকার বিশেষ ব্যবস্থা
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
                    গ্রামীণ এলাকার কাঁচা রাস্তা, বর্ষাকাল, নেটওয়ার্ক সমস্যা ইত্যাদি বিবেচনা করে 
                    আমাদের ডেলিভারি সিস্টেম তৈরি। স্থানীয় পরিচিত ব্যক্তির রেফারেন্স নিলে ডেলিভারি সহজ হয়।
                  </Typography>
                  <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                    হাট বা বাজারের দিনে ডেলিভারি ব্যবস্থা ভিন্ন হতে পারে। 
                    প্রাকৃতিক দুর্যোগের সময় ডেলিভারি স্থগিত থাকতে পারে।
                  </Typography>
                </AccordionDetails>
              </Accordion>

              <Accordion>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography variant="h6" sx={{ fontWeight: 600 }}>
                    ক্যাশ অন ডেলিভারি ও পেমেন্ট
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
                    গ্রামীণ এলাকার সুবিধার জন্য ক্যাশ অন ডেলিভারি সেবা রয়েছে। 
                    এর জন্য মাত্র ১৫ টাকা অতিরিক্ত চার্জ। পণ্যের দাম ও ডেলিভারি চার্জ একসাথে দিতে হবে।
                  </Typography>
                  <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                    মোবাইল ব্যাংকিং বা অনলাইন পেমেন্টেও সুবিধা রয়েছে। 
                    আগাম পেমেন্ট করলে ডেলিভারি দ্রুত হয়।
                  </Typography>
                </AccordionDetails>
              </Accordion>
            </Paper>
          </Box>

          {/* Contact for Delivery */}
          <Paper
            sx={{
              p: 6,
              textAlign: 'center',
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              color: 'white',
              borderRadius: 3,
              mt: '80px'
            }}
          >
            <LocalShippingIcon sx={{ fontSize: 64, mb: 2, opacity: 0.9 }} />
            <Typography variant="h4" gutterBottom sx={{ fontWeight: 600 }}>
              গ্রামীণ ডেলিভারি সহায়তা
            </Typography>
            <Typography variant="h6" sx={{ mb: 4, opacity: 0.9, maxWidth: '600px', mx: 'auto' }}>
              ডেলিভারি নিয়ে কোনো সমস্যা বা প্রশ্ন থাকলে আমাদের সাথে যোগাযোগ করুন। 
              আমরা গ্রামীণ এলাকার চ্যালেঞ্জ বুঝি।
            </Typography>
            <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap' }}>
              <MuiLink
                component={Link}
                to="/contact"
                sx={{
                  bgcolor: 'white',
                  color: 'primary.main',
                  px: 4,
                  py: 1.5,
                  borderRadius: 2,
                  textDecoration: 'none',
                  fontWeight: 600,
                  '&:hover': {
                    bgcolor: 'grey.100'
                  }
                }}
              >
                যোগাযোগ করুন
              </MuiLink>
              <MuiLink
                component={Link}
                to="/help"
                sx={{
                  border: '2px solid white',
                  color: 'white',
                  px: 4,
                  py: 1.5,
                  borderRadius: 2,
                  textDecoration: 'none',
                  fontWeight: 600,
                  '&:hover': {
                    bgcolor: 'rgba(255,255,255,0.1)'
                  }
                }}
              >
                সাহায্য কেন্দ্র
              </MuiLink>
            </Box>
          </Paper>
        </Container>
      </Box>
      <Footer />
    </>
  );
};

export default DeliveryPolicy; 